import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../services/apiClient';
import { brandConfig } from '../config/brands';

type PublicHomeBranding = {
  home_hero_title: string | null;
  home_hero_subtitle: string | null;
};

/**
 * 公開ホーム (未ログイン閲覧) 用のヒーロー文言を認証不要で取得する。
 *
 * ログイン時の usePartnerBranding は /partner/branding (認証必須) を使うため、
 * 未ログインでは認証不要の /partner/login-branding から同じ文言を引く。
 * 決済系の値 (stripe_publishable_key 等) は含まない表示専用フック。
 */
export function usePublicHomeBranding(enabled: boolean) {
  const { data } = useQuery<PublicHomeBranding>({
    queryKey: ['partner-login-branding-public', brandConfig.id],
    queryFn: async () => {
      const res = await apiClient.get<PublicHomeBranding>(
        `/partner/login-branding?partner_code=${encodeURIComponent(brandConfig.id)}`,
      );
      return res.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    homeHeroTitle: data?.home_hero_title ?? '',
    homeHeroSubtitle: data?.home_hero_subtitle ?? '',
  };
}
